import axios from './axios';

export const sendNotification = notification => axios.post('/core/notifications', notification);

/**
 * start notifications search
 * @param { pagination, filter } params
 * @returns {AxiosPromise<any>}
 */
export const getNotifications = params => axios.post('/core/notifications/search', params);

export const getNotificationsHistory = params =>
  axios.post('/core/notifications/history/search', params);

export const getNotificationHistoryById = id => axios.get(`/core/notifications/history/${id}`);
export const getNotificationHistoryDeliveryStatus = id =>
  axios.get(`/core/notifications/history/${id}/statuses`);

export const getUnreadNotifications = () => axios.get('/core/notifications/count');
export const getNotificationById = id => axios.get(`/core/notifications/${id}`);
export const getNotificationDeliveryStatus = id => axios.get(`/core/notifications/${id}/statuses`);

/**
 * send notification response
 * @param {string} notificationId
 */
export const sendNotificationResponse = (notificationId, notificationResponse) =>
  axios.post(`/core/notifications/${notificationId}/responses`, {
    notificationResponse,
  });

// filter based
// Create notification with filters
export const createNotificationWithFilters = notificationRequest =>
  axios.post('/core/notifications/filters', notificationRequest);

// Get list of users targeted by the filter
export const getNotificationTargets = notificationFiltersRequest =>
  axios.post('/core/notifications/filters/targets', notificationFiltersRequest);

// Get list of available filters with their options
export const getNotificationFilterOptions = notificationFiltersRequest =>
  axios.post('/core/notifications/filters/list', notificationFiltersRequest);

// List available receivers
export const getNotificationReceivers = () => axios.get('/core/notifications/filters/receivers');
